import { useState, useEffect, useContext, useCallback, useRef } from "react";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../../utils/secure-route/AuthContext";
import { useToastHandler } from "../../../../common/ToastHandler";
import { toast } from "react-toastify";

import useSwal from "../../../../common/ReusableComponent/useSwal";

const ProductController = () => {
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const [productTitle, setProductTitle] = useState("");
  const [purchasePrice, setPurchasePrice] = useState("");
  const [sellingPrice, setSellingPrice] = useState("");
  const [uom, setUom] = useState("");
  const [totalPcInUom, setTotalPcInUom] = useState("");
  // const [category, setCategory] = useState("");
  const [barcode, setBarcode] = useState("");
  const [openingInventory, setOpeningInventory] = useState("0");
  // Optional - only perishable products need this; blank means no expiry.
  const [expiryDate, setExpiryDate] = useState("");
  const [productList, setProductList] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editProductId, setEditProductId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [purchasePriceError, setPurchasePriceError] = useState(null);
  const [sellingPriceError, setSellingPriceError] = useState(null);
  const [assignBarcode, setAssignBarcode] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [selectedVendorName, setSelectedVendorName] = useState("");

  const [showVendorModal, setShowVendorModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedUom, setSelectedUom] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [productImage, setProductImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [autoGenerateBarcode, setAutoGenerateBarcode] = useState(false);
  const [shortDescription, setShortDescription] = useState("");
  const [longDescription, setLongDescription] = useState("");
  // Excludes this product from other stores' "Find Product in Other Store"
  // search (Stock Transfer feature) when true.
  const [hideFromOtherStores, setHideFromOtherStores] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [videoFile, setVideoFile] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [galleryPreview, setGalleryPreview] = useState([]);
  const [selectedWeightUnit, setSelectedWeightUnit] = useState(null);
  const [weightValue, setWeightValue] = useState("");

  const [errors, setErrors] = useState({
    title: "",
    // category: "",
    purchasePrice: "",
    sellingPrice: "",
    totalPcInUom: "",
    barcode: ""
  });
  const fileInputRef = useRef(null);
  // Debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 400); // 400ms debounce
    return () => clearTimeout(handler);
  }, [searchTerm]);

  // Only call API when debouncedSearchTerm changes
  useEffect(() => {
    const trimmed = debouncedSearchTerm.trim();
    if (trimmed === "" || trimmed.length >= 2) {
      fetchProductData({ page: currentPage, search: trimmed });
    }

  }, [currentPage, reloadData, debouncedSearchTerm]);

  const { Post, Patch, Delete, getAPI, _Get, PostPaginatedData, GetPaginatedData, PatchFormData, PostDataForm } = useApi();
  const { confirmDelete } = useSwal();
  const { handleToast } = useToastHandler()

  const handleProductTitleChange = (e) => {
    const value = e.target.value;

    setProductTitle(value);

    setErrors(prev => ({
      ...prev,
      title: ""
    }));
  };
  // const handleCategoryChange = (e) => {
  //   const value = e.target.value;
  //   setCategory(value.charAt(0).toUpperCase() + value.slice(1));

  //   setErrors(prev => ({ ...prev, category: "" }));
  // };
  const handleTitleBlur = () => {
    if (!productTitle.trim()) {
      setErrors(prev => ({
        ...prev,
        title: "Product title is required"
      }));
    }
  };

  // const handleCategoryBlur = () => {
  //   if (!category.trim()) {
  //     setErrors(prev => ({
  //       ...prev,
  //       category: "Category is required"
  //     }));
  //   }
  // };

  const handleOpeningInventoryChange = (e) => {
    const { value } = e.target;
    if (value.startsWith('0') && value.length > 1) {
      setOpeningInventory(value.slice(1));
      return;
    }
    if (value.length <= 10) {
      setOpeningInventory(value);
    }
  };

  const handleFocusOpeningInventory = () => {
    if (openingInventory === "0") {
      setOpeningInventory("");
    }
  };

  const handleBlurOpeningInventory = () => {
    if (openingInventory === "") {
      setOpeningInventory("0");
    }
  };

  const handlePurchasePriceChange = (e) => {
    const { value } = e.target;
    if (value.length <= 10) {
      setPurchasePrice(value);
      setPurchasePriceError("");
    }
  };

  const handleSellingPriceChange = (e) => {
    const { value } = e.target;
    if (value.length <= 10) {
      setSellingPrice(value);
      setSellingPriceError("");
    }
  };

  const handleUomChange = (e) => setUom(e.target.value);

  const handleTotalPcInUomChange = (e) => {
    const { value } = e.target;
    toast.dismiss();

    if (selectedUom && selectedUom.uom_title === 'Piece (pc)') {
      if (value === '1') {
        setTotalPcInUom(value);
      } else {
        setTotalPcInUom('1');
        handleToast({
          type: "ERROR",
          message: "For Piece (pc) UOM, total pieces must be 1"
        })
      }
    } else {
      setTotalPcInUom(value);
    }
  };
  // const handleProductImageChange = (e) => {
  //   const file = e.target.files[0];
  //   setProductImage(file);
  // };

  // const handleProductImageChange = (e) => {
  //   const file = e.target.files[0];

  //   if (!file) return;

  //   setProductImage(file);

  //   const previewUrl = URL.createObjectURL(file);
  //   setImagePreview(previewUrl);
  // };
  const handleProductImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setProductImage(file);

    const previewUrl = URL.createObjectURL(file);
    setImagePreview(previewUrl);
  };
  const handleBarcodeChange = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      return;
    }
    setBarcode(e.target.value);
  };
  const handlePurchasePriceBlur = () => {
    if (!purchasePrice) {
      setErrors(prev => ({
        ...prev,
        purchasePrice: "Purchase price is required"
      }));
    }
  };
  const handleSellingPriceBlur = () => {

    if (!sellingPrice) {
      setErrors(prev => ({
        ...prev,
        sellingPrice: "Selling price is required"
      }));
      return;
    }

    if (parseFloat(sellingPrice) < parseFloat(purchasePrice)) {
      setSellingPriceError("Selling price cannot be less than purchase price.");
    } else {
      setSellingPriceError("");
    }
  };
  const handleTotalPcBlur = () => {
    if (!totalPcInUom) {
      setErrors(prev => ({
        ...prev,
        totalPcInUom: "Total Pc in UOM is required"
      }));
    }
  };

  const handleOpenModal = () => {
    if (!isEditMode) {
      resetForm();
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setAssignBarcode(false);
    resetForm();
  };


  const handleVendorChange = (e) => {
    const vendorId = e.target.value;
    if (vendorId === "add-vendor") {
      setShowVendorModal(true);
      return;
    }
    if (vendorId === "") {
      setSelectedVendorId("");
      setSelectedVendorName("");
      return;
    }
    const selectedVendor = vendors.find((vendor) => vendor.id === vendorId);
    if (selectedVendor) {
      setSelectedVendorId(selectedVendor.id);
      setSelectedVendorName(selectedVendor.name);
    }
  };

  const handleCloseVendorModal = () => {
    setShowVendorModal(false);
  };

  const updateVendors = (newVendor) => {
    setVendors((prev) => [...prev, newVendor]);
  };

  const handleVendorAdded = async (newVendor) => {
    try {
      setSelectedVendorId(newVendor.id);
      setSelectedVendorName(newVendor.name);
      setShowVendorModal(false);
    } catch (error) {
      console.error("Error handling new vendor:", error);
      handleToast({
        type: "ERROR",
        message: "Error updating vendors list"
      })
    }
  };

  const fetchProductData = async ({ page = 1, search = "" } = {}) => {
    try {
      setLoading(true);
      if (search && search.trim().length > 0 && search.trim().length < 2) {
        setLoading(false);
        return {
          data: [],
          totalCount: 0,
          totalPages: 1,
          currentPage: page
        };
      }
      const response = await PostPaginatedData("showProductAndInventory", {
        page,
        search: search || undefined,
        queryParams: {},
        body: {}
      });
      setProductList(response.data);
      setTotalCount(response.totalCount);
      return {
        data: response.data,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / 10),
        currentPage: page
      };
    } catch (error) {
      console.error("Failed to fetch product list:", error);
      handleToast({
        type: "ERROR",
        message: "Failed to fetch product list: " + (error.message || "Unknown error")
      });

      setProductList([]);
      setTotalCount(0);

      return {
        data: [],
        totalCount: 0,
        totalPages: 1,
        currentPage: page
      };
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleDataUpdate = () => {
    fetchProductData({ page: currentPage, search: debouncedSearchTerm });
  };
  // useEffect(() => {
  //   fetchSegmentId();
  // }, []);
  // const fetchSegmentId = () => {
  //   Post("getProductAndInventory")
  //     .then((response) => {
  //       if (response.data.results && response.data.results.length > 0) {
  //         const product = response.data.results[0];
  //         if (product.segments && product.segments.length > 0) {
  //           const segmentId = product.segments[0].id;
  //         } else {
  //           console.error("No segments found.");
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching product data:", error);
  //       handleToast({
  //         type: "ERROR",
  //         message: "Error fetching product data:" + error
  //       })
  //     });
  // };
    const validateForm = () => {

    const newErrors = {};

    if (!productTitle.trim()) {
      newErrors.title = "Product title is required";
    }

    if (!selectedCategory || selectedCategory.length === 0) {
      newErrors.category = "Category is required";
    }

    if (!purchasePrice) {
      newErrors.purchasePrice = "Purchase price is required";
    }

    if (!sellingPrice) {
      newErrors.sellingPrice = "Selling price is required";
    }

    if (!totalPcInUom) {
      newErrors.totalPcInUom = "Total Pc in UOM is required";
    }
    if (!autoGenerateBarcode && !barcode.trim()) {
      newErrors.barcode = "Barcode is required";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleRemovePrimaryImage = () => {
    setProductImage(null);
    setImagePreview(null);
  };
  
  
  
  const handleAddProduct = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // =========================
    // PATCH (EDIT)
    // =========================
    if (isEditMode) {

      const patchData = new FormData();

      patchData.append("title", productTitle);

      if (selectedCategory?.length) {
        selectedCategory.forEach((cat) => {
          patchData.append("categories", cat.id);
        });
      }

      if (productImage) {
        patchData.append("product_image", productImage);
      }

      galleryImages.forEach((img, index) => {
        patchData.append(`media_gallery_images[${index}]`, img);
      });

      videoFile.forEach((vid, index) => {
        patchData.append(`media_gallery_videos[${index}]`, vid);
      });

      patchData.append("short_description", shortDescription);
      patchData.append("long_description", longDescription);
      patchData.append("hide_from_other_stores", hideFromOtherStores ? "true" : "false");

      if (weightValue) {
        patchData.append("weight_value", weightValue);
      }

      if (selectedWeightUnit) {
        patchData.append("weight_unit", selectedWeightUnit.weight_title);
      }

      PatchFormData("productData", editProductId, patchData)
        .then((response) => {

          handleToast({
            type: "SUCCESS",
            message: "Product updated successfully!"
          });

          const updatedProductList = productList.map((product) =>
            product.id === editProductId ? response : product
          );

          setProductList(updatedProductList);
          setReloadData(prev => !prev);

          resetForm();
          handleCloseModal();
        })
        .catch((error) => {

          console.error("Error updating product:", error);

          handleToast({
            type: "ERROR",
            message: "Error updating product"
          });
        });

      return;
    }

    // =========================
    // POST (ADD)
    // =========================

    const formData = new FormData();

    formData.append("store", storeId);
    formData.append("title", productTitle);

    formData.append("purchase_price", purchasePrice);
    formData.append("selling_price", sellingPrice);

    if (selectedCategory?.length) {
      selectedCategory.forEach((cat) => {
        formData.append("categories", cat.id);
      });
    }

    formData.append("total_pc_in_uom", totalPcInUom);
    formData.append("opening_inventory", openingInventory || "0");

    if (expiryDate) {
      formData.append("expiry_date", expiryDate);
    }

    formData.append("short_description", shortDescription);
    formData.append("long_description", longDescription);
    formData.append("hide_from_other_stores", hideFromOtherStores ? "true" : "false");

    if (selectedUom) {
      formData.append("uom", selectedUom.id);
    }

    if (!autoGenerateBarcode && barcode) {
      formData.append("barcode", barcode.trim());
    }

    if (selectedVendorId) {
      formData.append("vendor", selectedVendorId);
    }

    if (selectedVendorName) {
      formData.append("vendor_name", selectedVendorName);
    }

    if (productImage) {
      formData.append("product_image", productImage);
    }

    galleryImages.forEach((img, index) => {
      formData.append(`media_gallery_images[${index}]`, img);
    });

    videoFile.forEach((vid, index) => {
      formData.append(`media_gallery_videos[${index}]`, vid);
    });

    if (weightValue) {
      formData.append("weight_value", weightValue);
    }

    if (selectedWeightUnit) {
      formData.append("weight_unit", selectedWeightUnit.weight_title);
    }

    PostDataForm("productData", formData)
      .then(() => {

        handleToast({
          type: "SUCCESS",
          message: "Product added successfully!"
        });

        setReloadData(prev => !prev);

        resetForm();
        handleCloseModal();
      })
      .catch((error) => {
        const data = error?.response?.data;
        let errorMessage = "Error adding product";

        if (data) {
          if (typeof data === "string") {
            errorMessage = data;
          } else if (data.detail) {
            errorMessage = data.detail;
          } else if (data.message) {
            errorMessage = data.message;
          } else if (data.error) {
            errorMessage = data.error;
          } else {
            const firstKey = Object.keys(data)[0];
            if (firstKey) {
              const val = data[firstKey];
              errorMessage = `${firstKey}: ${Array.isArray(val) ? val[0] : val}`;
            }
          }
        }

        handleToast({
          type: "ERROR",
          message: errorMessage
        });
      });
  };

  // const handleAddProduct = (e) => {

  //   e.preventDefault();

  //   if (!validateForm()) return;

  //   const formData = new FormData();

  //   formData.append("store", storeId);
  //   formData.append("title", productTitle);
  //   if (!isEditMode) {
  //     formData.append("purchase_price", purchasePrice);
  //     formData.append("selling_price", sellingPrice);
  //   }
  //   if (selectedCategory?.length) {
  //     selectedCategory.forEach((cat) => {
  //       formData.append("categories", cat.id);
  //     });
  //   }
  //   formData.append("total_pc_in_uom", totalPcInUom);
  //   formData.append("opening_inventory", openingInventory || "0");
  //   formData.append("short_description", shortDescription);
  //   formData.append("long_description", longDescription);
  //   if (selectedUom) {
  //     formData.append("uom", selectedUom.id);
  //   }

  //   if (!autoGenerateBarcode && barcode) {
  //     formData.append("barcode", barcode.trim());
  //   }

  //   if (selectedVendorId) {
  //     formData.append("vendor", selectedVendorId);
  //   }

  //   if (selectedVendorName) {
  //     formData.append("vendor_name", selectedVendorName);
  //   }

  //   if (productImage) {
  //     formData.append("product_image", productImage);
  //   }
  //   galleryImages.forEach((img, index) => {
  //     formData.append(`media_gallery_images[${index}]`, img);
  //   });

  //   videoFile.forEach((vid, index) => {
  //     formData.append(`media_gallery_videos[${index}]`, vid);
  //   });
  //   if (weightValue) {
  //     formData.append("weight_value", weightValue);
  //   }

  //   if (selectedWeightUnit) {
  //     formData.append("weight_unit", selectedWeightUnit.weight_title);
  //   }
  //   if (isEditMode) {

  //     PatchFormData("productData", editProductId, formData)

  //       .then((response) => {

  //         handleToast({
  //           type: "SUCCESS",
  //           message: "Product updated successfully!"
  //         });

  //         const updatedProductList = productList.map((product) =>
  //           product.id === editProductId ? response : product
  //         );

  //         setProductList(updatedProductList);

  //         setReloadData(prev => !prev);

  //         resetForm();
  //         handleCloseModal();

  //       })

  //       .catch((error) => {

  //         console.error("Error updating product:", error);

  //         handleToast({
  //           type: "ERROR",
  //           message: "Error updating product"
  //         });

  //       });

  //   } else {

  //     PostDataForm("productData", formData)

  //       .then(() => {

  //         handleToast({
  //           type: "SUCCESS",
  //           message: "Product added successfully!"
  //         });

  //         setReloadData(prev => !prev);

  //         resetForm();
  //         handleCloseModal();

  //       })

  //       .catch((error) => {

  //         const errorMessage =
  //           error?.response?.data?.detail ||
  //           error?.response?.data?.message ||
  //           "Error adding product";

  //         console.error("Error adding product:", errorMessage);

  //         handleToast({
  //           type: "ERROR",
  //           message: errorMessage
  //         });

  //       });

  //   }

  // };
  const resetForm = () => {
    setProductTitle("");
    setPurchasePrice("");
    setSellingPrice("");
    setUom("");
    setTotalPcInUom("");
    setSelectedCategory([]);
    setOpeningInventory("0");
    setExpiryDate("");
    setBarcode("");

    setPurchasePriceError("");
    setSellingPriceError("");

    setIsEditMode(false);
    setEditProductId(null);

    setSelectedVendorId("");
    setSelectedVendorName("");

    setSelectedUom(null);

    setProductImage(null);
    setImagePreview(null);
    setGalleryImages([]);
    setGalleryPreview([]);
    setVideoFile([]);
    setShortDescription("");
    setLongDescription("");
    setHideFromOtherStores(false);
    setWeightValue("");
    setSelectedWeightUnit(null);
  };


  const handleImportProducts = async (file) => {

    if (!file) {
      toast.error("Please select a CSV file");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {

      await PostDataForm("importBulkProduct", formData);

      handleToast({
        type: "SUCCESS",
        message: "Products imported successfully"
      });

      setReloadData(prev => !prev);

    } catch (error) {

      console.error(error);

      handleToast({
        type: "ERROR",
        message: "CSV import failed"
      });

    }
  };
  const { getHost } = useApi();
  const handleEditProduct = (product , selectedSegment) => {

    const host = getHost();

    setProductTitle(product.title);
    setShortDescription(product.short_description || "");
    setLongDescription(product.long_description || "");
    setHideFromOtherStores(Boolean(product.hide_from_other_stores));
    if (product.segments && product.segments.length > 0) {
      const segment = selectedSegment || product.segments[0];
      setPurchasePrice(segment.purchase_price);
      setSellingPrice(segment.selling_price);
      setSelectedUom({
        id: segment.uom,
        uom_title: segment.uom_title || "Unknown UOM",
      });
      setTotalPcInUom(segment.total_pc_in_uom);
      setBarcode(
        segment.segment_barcode === "None" ? "" : segment.segment_barcode
      );
    }
    if (product.categories?.assigned?.length) {
      const formatted = product.categories.assigned.map((cat) => ({
        id: cat.id,
        name: cat.name
      }));
      setSelectedCategory(formatted);
    } else {
      setSelectedCategory([]);
    }

    // WEIGHT
    setWeightValue(product.weight_value || "");

    if (product.weight_unit) {
      setSelectedWeightUnit({
        weight_title: product.weight_unit
      });
    } else {
      setSelectedWeightUnit(null);
    }
    // PRIMARY IMAGE
    if (product.product_image) {
      setImagePreview(`${host}${product.product_image}`);
    } else {
      setImagePreview(null);
    }

    // IMPORTANT → don't resend old image
    setProductImage(null);

    // ✅ GALLERY FIX
    if (product.media_gallery && product.media_gallery.length > 0) {
      const previews = product.media_gallery.map((media) => ({
        url: media.image
          ? `${host}${media.image}`
          : `${host}${media.video}`,
        type: media.image ? "image" : "video"
      }));

      setGalleryPreview(previews);
    } else {
      setGalleryPreview([]);
    }
    // IMPORTANT: clear upload arrays
    setGalleryImages([]);
    setVideoFile([]);
    setOpeningInventory(product.opening_inventory);
    setIsEditMode(true);
    setEditProductId(product.id);
    setShowModal(true);
    setSelectedVendorId(product.vendor || "");
    setSelectedVendorName(product.vendor_name || "");
  };

  const handleDeleteProduct = async (item, segment = null) => {
    if (!segment) {
      return;
    }
    const result = await confirmDelete();
    if (result.isConfirmed && segment) {
      Delete("segmentData", segment.id)
        .then(() => {
          toast.success("Segment deleted!");
          setReloadData((prev) => !prev);
        })
        .catch((error) => {
          console.error("Error deleting segment:", error);
          toast.error("Failed to delete segment.");
        });
    }
  };


  const handleUpdateBarcode = async (segmentId) => {
    try {
      const requestBody = {
        segment_barcode: barcode.trim(),
      };
      await Patch("segmentData", segmentId, requestBody);
      toast.success("Barcode updated successfully!");

      await fetchProductData({ page: currentPage, search: debouncedSearchTerm });
      setBarcode("");
      return true;
    } catch (error) {
      console.error("Error updating barcode:", error);
      toast.error("Error updating barcode");
      return false;
    }
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };


  // GALLERY IMAGE + VIDEO UPLOAD

  const handleGalleryUpload = (e) => {
    const files = Array.from(e.target.files);

    const images = [];
    const videos = [];
    const previews = [];

    files.forEach((file) => {
      if (file.type.startsWith("image")) {
        images.push(file);
      }

      if (file.type.startsWith("video")) {
        videos.push(file);
      }

      previews.push({
        url: URL.createObjectURL(file),
        type: file.type.startsWith("video") ? "video" : "image",
      });
    });

    setGalleryImages((prev = []) => [...prev, ...images]);
    setVideoFile((prev = []) => [...prev, ...videos]);
    setGalleryPreview((prev = []) => [...prev, ...previews]);
  };

  // REMOVE MEDIA

  const removeGalleryImage = (index) => {
    setGalleryPreview((prev) => prev.filter((_, i) => i !== index));

    setGalleryImages((prev) => {
      const copy = [...prev];
      copy.splice(index, 1);
      return copy;
    });

    setVideoFile((prev) => {
      const copy = [...prev];
      copy.splice(index, 1);
      return copy;
    });
  };

  return {
    productTitle,
    purchasePrice,
    sellingPrice,
    uom,

    openingInventory,
    expiryDate,
    setExpiryDate,
    setUom,
    barcode,
    setBarcode,
    productList,
    isEditMode,
    handleProductTitleChange,
    // handleCategoryChange,
    handleOpeningInventoryChange,
    handlePurchasePriceChange,
    handleSellingPriceChange,
    handleUomChange,
    handleBarcodeChange,
    handleAddProduct,
    handleDeleteProduct,
    handleEditProduct,
    showModal,
    handleOpenModal,
    handleCloseModal,
    handleUpdateBarcode,
    setProductList,
    purchasePriceError,
    sellingPriceError,
    handleSellingPriceBlur,
    assignBarcode,
    setAssignBarcode,
    vendors,
    selectedVendorId,
    selectedVendorName,
    handleVendorChange,
    showVendorModal,
    handleCloseVendorModal,
    updateVendors,
    handleVendorAdded,
    totalPcInUom,
    resetForm,
    handleTotalPcInUomChange,
    currentPage,
    totalCount,
    loading,
    handlePageChange,
    handleDataUpdate,
    selectedUom,
    setSelectedUom,
    handleBlurOpeningInventory,
    handleFocusOpeningInventory,
    setOpeningInventory,
    searchTerm,
    handleSearch,
    vendors,
    selectedVendorId,
    setSelectedVendorId,
    showVendorModal,
    setShowVendorModal,
    selectedVendorName,
    setSelectedVendorName,
    handleCloseVendorModal,
    updateVendors,
    handleVendorAdded,
    errors,
    handleTitleBlur,
    // handleCategoryBlur,
    handlePurchasePriceBlur,
    handleTotalPcBlur,
    productImage,
    handleProductImageChange,
    imagePreview,
    autoGenerateBarcode,
    setAutoGenerateBarcode,
    handleImportProducts,
    fileInputRef,
    galleryPreview,
    handleRemovePrimaryImage,
    handleGalleryUpload,
    removeGalleryImage,
    fileInputRef,
    shortDescription,
    longDescription,
    setLongDescription,
    setShortDescription,
    hideFromOtherStores,
    setHideFromOtherStores,
    selectedCategory,
    setSelectedCategory,
    weightValue,
    setWeightValue,
    selectedWeightUnit,
    setSelectedWeightUnit,
  };
};

export default ProductController;